import React from "react";
import { Link } from "react-router-dom";
import { URL_Route } from "urlRouts";
import { baseURL } from "API/Axios";

interface Props {
  TableContent: any;
  HeaderMinWidth?: Array<any>;
}

const ListAgentTable: React.FC<Props> = ({ TableContent, HeaderMinWidth }) => {
  return (
    <>
      {TableContent.map((item: any, key: any) => (
        <div
          key={key}
          style={{
            borderBottom:
              key === TableContent.length - 1 ? "none" : "1px solid #f6f6f6",
          }}
          className="table-content"
        >
          <p style={{minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[0] : '' }}>{item.fullName}</p>
          <p style={{minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[1] : '' }}>{item.mobile}</p>
          <p style={{minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[2] : '' }}>{item.email}</p>
          <p style={{minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[3] : '' }}>{item.isActive ? 'Active' : 'Not Active'}</p>
          <p style={{minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[4] : '' }}><img style={{height:'50px',width:'50px'}} alt={'Not Found'} src={baseURL+item.imageURL}/></p>
          <p style={{minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[5] : '' }}><Link className="" to={URL_Route.Edit_Agent+`?user-id=${item.userId}`}>Edit</Link></p>
        </div>
      ))}
    </>
  );
};

export default ListAgentTable;
